import { BehaviorSubject } from 'rxjs';
import { AudioPlayTask, AudioTaskState } from '../audio/audio-play-task';
import { Injectable, signal } from '@angular/core';
import { IMessage } from '../domain/message';
import { AudioStreamDestination } from '../audio/streaming/audio-stream-destination';

@Injectable({ providedIn: 'root' })
export class AudioTaskStore {
    private readonly _currentTaskMessage = new BehaviorSubject<IMessage | null>(null);
    private readonly _currentAudioTask = new BehaviorSubject<AudioPlayTask | null>(null);
    private readonly _currentAudioTaskState = new BehaviorSubject<AudioTaskState>('unknown');
    private _audioStreamDestination: AudioStreamDestination | null = null;

    public currentAudioTask = this._currentAudioTask.asObservable();
    public currentAudioTaskState = this._currentAudioTaskState.asObservable();
    public currentMessage = this._currentTaskMessage.asObservable();

    public get audioStreamDestination(): AudioStreamDestination | null {
        return this._audioStreamDestination;
    }

    public set audioStreamDestination(value: AudioStreamDestination | null) {
        this._audioStreamDestination = value;
    }

    public async setCurrentTask(task: AudioPlayTask) {
        const oldTask = this._currentAudioTask.value;
        if (oldTask !== null) {
            await oldTask.stop();
        }

        task.state.subscribe((state) => this._currentAudioTaskState.next(state));

        this._currentAudioTask.next(task);

        await task.init();
    }

    public getCurrentTask() {
        return this._currentAudioTask.value;
    }

    public async stopCurrentTask() {
        const currentTask = this.getCurrentTask();
        if (currentTask === null) {
            return;
        }

        await currentTask.stop();
    }

    public setCurrentMessage(message: IMessage | null) {
        this._currentTaskMessage.next(message);
    }
}
